import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InventarioListComponent } from './inventario-list/inventario-list.component';
import { EtapaListComponent } from './etapa-list/etapa-list.component';
import { DirectivesModule } from '../shared/directives/directives.module';
import { PipesModule } from '../shared/pipes/pipes.module';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { RouterModule } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { BrowserModule } from '@angular/platform-browser';
import { DividerModule } from 'primeng/divider';
import { TabViewModule } from 'primeng/tabview';
import { TimelineModule } from 'primeng/timeline';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ListboxModule } from 'primeng/listbox';
import { GMapModule } from 'primeng/gmap';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedModule } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PaginatorModule } from 'primeng/paginator';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { InputMaskModule } from 'primeng/inputmask';
import { ProgressBarModule } from 'primeng/progressbar';
import { PainelModule } from '../shared/components/painel/painel.module';
import { TreeModule } from 'primeng/tree';
import { SimNaoPipe } from '../shared/pipes/sim-nao.pipe';
import { ContagemAdicionarComponent } from './contagem-adicionar/contagem-adicionar.component';
import { HttpClientModule } from '@angular/common/http';
import { CardModule } from 'primeng/card';



@NgModule({
  declarations: [InventarioListComponent, EtapaListComponent, ContagemAdicionarComponent],
  imports: [
    CommonModule,
    
    PipesModule,
    TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,    
    ButtonModule,
    RatingModule,
    InputTextModule,
    ToolbarModule,
    FileUploadModule,
    DialogModule,
    RouterModule,
    ConfirmDialogModule,
    RadioButtonModule,
    InputTextModule,
    InputNumberModule,    
    BrowserModule,
    DividerModule,
    TabViewModule,
    TimelineModule,
    ScrollPanelModule,
    ListboxModule,
    GMapModule,
    SelectButtonModule,
    DropdownModule,
    CheckboxModule,
    SharedModule,
    ToastModule,
    BrowserAnimationsModule,
    PaginatorModule,
    DirectivesModule,
    CalendarModule,
    TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    ToolbarModule,
    DialogModule,
    ConfirmDialogModule,        
    BrowserModule,
    ToastModule,
    SharedModule,
    CalendarModule,
    CheckboxModule,
    ScrollPanelModule,
    FieldsetModule,
    DropdownModule,
    InputNumberModule,    
    InputMaskModule,
    SelectButtonModule ,
    ProgressBarModule ,
    PipesModule ,
    PainelModule,
    ListboxModule,
    TabViewModule,
    TimelineModule,
    DirectivesModule,
    CalendarModule,
    RouterModule,
    TreeModule,
    TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    ToolbarModule,
    DialogModule,
    ConfirmDialogModule,        
    BrowserModule,
    ToastModule,
    SharedModule,
    CalendarModule,
    CheckboxModule,
    ScrollPanelModule,
    FieldsetModule,
    DropdownModule,
    InputNumberModule,    
    InputMaskModule,
    SelectButtonModule ,
    ProgressBarModule ,
    PipesModule ,
    PainelModule,
    ListboxModule,
    TabViewModule,
    TimelineModule,
    DirectivesModule,
    CalendarModule,
    RouterModule,
    FileUploadModule,
    HttpClientModule,
    CardModule,
    RadioButtonModule,
  ],
  exports:[InventarioListComponent, EtapaListComponent, ContagemAdicionarComponent, ]
})
export class InventarioModule { }
